/** The one GPU texture an atlas fills in place, whatever three clones. */
import * as THREE from 'three';
import { sharedTexture } from '../sharedTexture.js';
import { carryMipChain, GODOT_DEFAULT_MIN_FILTER } from '../../resources/textures/texelTexture.js';
export class AtlasTexture extends sharedTexture(THREE.DataTexture) {
    constructor(name, colorSpace) {
        super(null, 1, 1, THREE.RGBAFormat, THREE.UnsignedByteType);
        this.name = name;
        this.colorSpace = colorSpace;
        this.generateMipmaps = false;
        this.magFilter = THREE.LinearFilter;
    }
}
/**
 * Fills `atlas` with `levels`, the largest first, through `carryMipChain`. A function, not a
 * method: a dev server reload hands an `AtlasTexture` an earlier evaluation built, and this reads
 * only its public fields. A texture's GPU storage keeps its first size, so a new size drops the old
 * storage before the levels upload. The same size uploads into it. An atlas is always a chain, so
 * fewer than two levels is an error.
 */
export function holdAtlasLevels(atlas, levels) {
    const [base] = levels;
    if (!base || levels.length < 2)
        throw new Error(`expected at least 2 atlas levels, got ${levels.length}`);
    if (base.width !== atlas.image.width || base.height !== atlas.image.height)
        atlas.dispose();
    carryMipChain(atlas, [...levels], GODOT_DEFAULT_MIN_FILTER);
    atlas.image = base;
    atlas.needsUpdate = true;
}
//# sourceMappingURL=atlasTexture.js.map